// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__HnYoU","row":"Node_row__QWx2l","label":"Node_label__3s5Bz","footer":"Node_footer__uvKgg"};